import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const coverUrl = (id, style = "disco") => `${API}/generations/${id}/cover.jpg?style=${style}`;
export const COVER_STYLES = [
  { key: "disco", name: "Disco" },
  { key: "vinyl", name: "Vinyle" },
  { key: "neon", name: "Néon" },
  { key: "retro", name: "Rétro" },
];

export const getSessionId = () => localStorage.getItem("session_id");
export const setSessionId = (id) => localStorage.setItem("session_id", id);
export const clearSession = () => localStorage.removeItem("session_id");

const client = axios.create({ baseURL: API });
client.interceptors.request.use((config) => {
  const sid = getSessionId();
  if (sid) config.headers["X-Session-Id"] = sid;
  return config;
});

export default client;
